import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const DetailContainer = styled.div({
  display: 'flex',
})

export const Cont = styled.div(props => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
}))

export const SContDetail = styled.div(props => ({
  display: 'flex',
  marginTop: props.sub ? '0' : '1rem',

  '&>div:first-child': {
    marginLeft: 0,
    flex: 1
  },

  '>div:first-child .toleft': {
    marginLeft: 0,
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  },

  '&>div': {
    marginLeft: '1rem',
    flex: 1
  }
}))

export const DpItemContainer = styled.div(props => ({
  display: 'flex',
  marginTop: props.sub ? '0' : '1rem',
  overflowX: 'scroll',

  '.dpItems':{
    width:'100%'
  },

  '@media only screen and (min-width: 600px)': {
    overflowX: 'unset',
  },

  '@media only screen and (min-width: 769px)': {
    overflowX: 'unset',
  },
}))

export const FooterCont = styled.div({
  display: 'flex',
  flexDirection: 'column',
  marginTop: '1rem',

  '>div': {
    display: 'flex',
    flex: 1,
    marginTop: '1rem',
  },

  '.title': {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    fontWeight: 'bold',
    flex: 1,

    '.halfRow': {
      width: '5%',
      marginLeft: '1rem',

      '.fieldRow': {
        marginBottom: 0
      }
    }
  },

  '.value': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '10rem',

    '.amount': {
      width: '5rem',
      textAlign: 'center'
    },
    '.currency': {
      width: '5rem',
      textAlign: 'center'
    }
  }
})

export const Field = styled.div({
  marginLeft: 0,
  justifyContent: 'flex-end',
  display: 'flex',
})
export const ItemSummaryRow = styled.div({
  display: 'flex',
  width: '100%',
  justifyContent: 'flex-end',

  'div.itemSummaryLabel': {
    fontWeight: 'bold',
  },

  'div.summaryValue': {
    display: 'flex',
    width: '80px',
    justifyContent: 'flex-end'
  },

  'div.currency': {
    display: 'flex',
    width: '60px',
    justifyContent: 'center'
  }
})
